import { useMemo, useState } from "react";
import { StepType } from "../../step";
import { UseStepperStateReturnType } from "./types";
import { getStepWithUpdatedIsPassed } from "./utils";

export const useStepperState = (
  stepsFromProps: Array<StepType>
): UseStepperStateReturnType => {
  const [steps, setSteps] = useState(stepsFromProps);

  const setActiveStep = (stepIndex: number) => {
    setSteps((previousSteps) =>
      previousSteps.map((step, index) => ({
        ...step,
        ...{ isActive: index === stepIndex },
      }))
    );
  };

  const setPassedStep = (stepIndex: number, isPassed?: boolean) => {
    setSteps((previousSteps) =>
      previousSteps.map((step, index) =>
        getStepWithUpdatedIsPassed(step, index, stepIndex, isPassed)
      )
    );
  };

  const activeStepIndex = useMemo(
    () => steps.findIndex(({ isActive }) => isActive),
    [steps]
  );

  const setPassedStepAndGoToNextStep = () => {
    setSteps((previousSteps) =>
      previousSteps.map((step, index) => ({
        ...getStepWithUpdatedIsPassed(step, index, activeStepIndex, true),
        ...{
          isActive:
            (activeStepIndex === previousSteps.length - 1 &&
              activeStepIndex === index) ||
            index - 1 === activeStepIndex,
        },
      }))
    );
  };

  const setNotPassedStepAndGoToPreviousStep = () => {
    setSteps((previousSteps) =>
      previousSteps.map((step, index) => ({
        ...getStepWithUpdatedIsPassed(step, index, activeStepIndex, false),
        ...{
          isActive:
            (activeStepIndex === 0 && activeStepIndex === index) ||
            index + 1 === activeStepIndex,
        },
      }))
    );
  };

  return {
    steps,
    activeStepIndex,
    setSteps,
    setActiveStep,
    setPassedStep,
    setPassedStepAndGoToNextStep,
    setNotPassedStepAndGoToPreviousStep,
  };
};
